/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoryInQuery } from '../../models/get-inventory-in-query';
import { GetInventoryInQueryResult } from '../../models/get-inventory-in-query-result';

export interface ApiNurseryManagerInventoryInGetInventoryInPost$Plain$Params {
      body?: GetInventoryInQuery
}

export function apiNurseryManagerInventoryInGetInventoryInPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryInGetInventoryInPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryInQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryInGetInventoryInPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoryInQueryResult>;
    })
  );
}

apiNurseryManagerInventoryInGetInventoryInPost$Plain.PATH = '/api/NurseryManager/InventoryIn/GetInventoryIn';
